/* tslint:disable */
/* eslint-disable */
/**
 * TOM STORAGE SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GeneralCargoItemPlanningDto } from '../model';
// @ts-ignore
import type { GeneralCargoOrderPlanningDto } from '../model';
// @ts-ignore
import type { GeneralCargoStockDto } from '../model';
// @ts-ignore
import type { GeneralCargoStockOccupancyDamageDto } from '../model';
// @ts-ignore
import type { OrderDamageQuantityDto } from '../model';
// @ts-ignore
import type { UpdateGeneralCargoOrderPlanningDto } from '../model';
// @ts-ignore
import type { UpdateGeneralCargoStockOccupancyDto } from '../model';
/**
 * GeneralCargoStockOccupanciesApi - axios parameter creator
 */
export const GeneralCargoStockOccupanciesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStockOccupanciesGetDamageInfoByOrderId: async (orderId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/GeneralCargoStockOccupancies/GetDamageInfoByOrderId/getDamageInfoByOrderId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (orderId !== undefined) {
                localVarQueryParameter['OrderId'] = orderId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [orderIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStockOccupanciesGetDamagesByOrderIds: async (orderIds?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/GeneralCargoStockOccupancies/GetDamagesByOrderIds/getDamagesByOrderIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (orderIds) {
                localVarQueryParameter['OrderIds'] = orderIds;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [orderId] 
         * @param {number} [cargoItemId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStockOccupanciesGetOrderPlanning: async (orderId?: number, cargoItemId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/GeneralCargoStockOccupancies/GetOrderPlanning`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }

            if (cargoItemId !== undefined) {
                localVarQueryParameter['cargoItemId'] = cargoItemId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [orderIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStockOccupanciesGetOrderPlanningByOrderIds: async (orderIds?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/GeneralCargoStockOccupancies/GetOrderPlanningByOrderIds/orderPlanningByOrderIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (orderIds) {
                localVarQueryParameter['orderIds'] = orderIds;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateGeneralCargoOrderPlanningDto} [updateGeneralCargoOrderPlanningDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStockOccupanciesPlanOrder: async (updateGeneralCargoOrderPlanningDto?: UpdateGeneralCargoOrderPlanningDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/GeneralCargoStockOccupancies/PlanOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGeneralCargoOrderPlanningDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateGeneralCargoStockOccupancyDto} [updateGeneralCargoStockOccupancyDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStockOccupanciesPutToStock: async (updateGeneralCargoStockOccupancyDto?: UpdateGeneralCargoStockOccupancyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/GeneralCargoStockOccupancies/PutToStock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGeneralCargoStockOccupancyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateGeneralCargoStockOccupancyDto} [updateGeneralCargoStockOccupancyDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStockOccupanciesTakeFromStock: async (updateGeneralCargoStockOccupancyDto?: UpdateGeneralCargoStockOccupancyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/GeneralCargoStockOccupancies/TakeFromStock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGeneralCargoStockOccupancyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStockOccupanciesUploadDamageFile: async (file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/GeneralCargoStockOccupancies/UploadDamageFile/uploadDamageFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeneralCargoStockOccupanciesApi - functional programming interface
 */
export const GeneralCargoStockOccupanciesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeneralCargoStockOccupanciesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalCargoStockOccupanciesGetDamageInfoByOrderId(orderId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GeneralCargoStockOccupancyDamageDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalCargoStockOccupanciesGetDamageInfoByOrderId(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoStockOccupanciesApi.generalCargoStockOccupanciesGetDamageInfoByOrderId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<number>} [orderIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalCargoStockOccupanciesGetDamagesByOrderIds(orderIds?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrderDamageQuantityDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalCargoStockOccupanciesGetDamagesByOrderIds(orderIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoStockOccupanciesApi.generalCargoStockOccupanciesGetDamagesByOrderIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [orderId] 
         * @param {number} [cargoItemId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalCargoStockOccupanciesGetOrderPlanning(orderId?: number, cargoItemId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GeneralCargoItemPlanningDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalCargoStockOccupanciesGetOrderPlanning(orderId, cargoItemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoStockOccupanciesApi.generalCargoStockOccupanciesGetOrderPlanning']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<number>} [orderIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalCargoStockOccupanciesGetOrderPlanningByOrderIds(orderIds?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GeneralCargoOrderPlanningDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalCargoStockOccupanciesGetOrderPlanningByOrderIds(orderIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoStockOccupanciesApi.generalCargoStockOccupanciesGetOrderPlanningByOrderIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateGeneralCargoOrderPlanningDto} [updateGeneralCargoOrderPlanningDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalCargoStockOccupanciesPlanOrder(updateGeneralCargoOrderPlanningDto?: UpdateGeneralCargoOrderPlanningDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GeneralCargoItemPlanningDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalCargoStockOccupanciesPlanOrder(updateGeneralCargoOrderPlanningDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoStockOccupanciesApi.generalCargoStockOccupanciesPlanOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateGeneralCargoStockOccupancyDto} [updateGeneralCargoStockOccupancyDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalCargoStockOccupanciesPutToStock(updateGeneralCargoStockOccupancyDto?: UpdateGeneralCargoStockOccupancyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralCargoStockDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalCargoStockOccupanciesPutToStock(updateGeneralCargoStockOccupancyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoStockOccupanciesApi.generalCargoStockOccupanciesPutToStock']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateGeneralCargoStockOccupancyDto} [updateGeneralCargoStockOccupancyDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalCargoStockOccupanciesTakeFromStock(updateGeneralCargoStockOccupancyDto?: UpdateGeneralCargoStockOccupancyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralCargoStockDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalCargoStockOccupanciesTakeFromStock(updateGeneralCargoStockOccupancyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoStockOccupanciesApi.generalCargoStockOccupanciesTakeFromStock']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalCargoStockOccupanciesUploadDamageFile(file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalCargoStockOccupanciesUploadDamageFile(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoStockOccupanciesApi.generalCargoStockOccupanciesUploadDamageFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GeneralCargoStockOccupanciesApi - factory interface
 */
export const GeneralCargoStockOccupanciesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeneralCargoStockOccupanciesApiFp(configuration)
    return {
        /**
         * 
         * @param {GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesGetDamageInfoByOrderIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStockOccupanciesGetDamageInfoByOrderId(requestParameters: GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesGetDamageInfoByOrderIdRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GeneralCargoStockOccupancyDamageDto>> {
            return localVarFp.generalCargoStockOccupanciesGetDamageInfoByOrderId(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesGetDamagesByOrderIdsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStockOccupanciesGetDamagesByOrderIds(requestParameters: GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesGetDamagesByOrderIdsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<OrderDamageQuantityDto>> {
            return localVarFp.generalCargoStockOccupanciesGetDamagesByOrderIds(requestParameters.orderIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesGetOrderPlanningRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStockOccupanciesGetOrderPlanning(requestParameters: GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesGetOrderPlanningRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GeneralCargoItemPlanningDto>> {
            return localVarFp.generalCargoStockOccupanciesGetOrderPlanning(requestParameters.orderId, requestParameters.cargoItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesGetOrderPlanningByOrderIdsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStockOccupanciesGetOrderPlanningByOrderIds(requestParameters: GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesGetOrderPlanningByOrderIdsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GeneralCargoOrderPlanningDto>> {
            return localVarFp.generalCargoStockOccupanciesGetOrderPlanningByOrderIds(requestParameters.orderIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesPlanOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStockOccupanciesPlanOrder(requestParameters: GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesPlanOrderRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GeneralCargoItemPlanningDto>> {
            return localVarFp.generalCargoStockOccupanciesPlanOrder(requestParameters.updateGeneralCargoOrderPlanningDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesPutToStockRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStockOccupanciesPutToStock(requestParameters: GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesPutToStockRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GeneralCargoStockDto> {
            return localVarFp.generalCargoStockOccupanciesPutToStock(requestParameters.updateGeneralCargoStockOccupancyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesTakeFromStockRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStockOccupanciesTakeFromStock(requestParameters: GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesTakeFromStockRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GeneralCargoStockDto> {
            return localVarFp.generalCargoStockOccupanciesTakeFromStock(requestParameters.updateGeneralCargoStockOccupancyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesUploadDamageFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStockOccupanciesUploadDamageFile(requestParameters: GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesUploadDamageFileRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.generalCargoStockOccupanciesUploadDamageFile(requestParameters.file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for generalCargoStockOccupanciesGetDamageInfoByOrderId operation in GeneralCargoStockOccupanciesApi.
 */
export interface GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesGetDamageInfoByOrderIdRequest {
    readonly orderId?: number
}

/**
 * Request parameters for generalCargoStockOccupanciesGetDamagesByOrderIds operation in GeneralCargoStockOccupanciesApi.
 */
export interface GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesGetDamagesByOrderIdsRequest {
    readonly orderIds?: Array<number>
}

/**
 * Request parameters for generalCargoStockOccupanciesGetOrderPlanning operation in GeneralCargoStockOccupanciesApi.
 */
export interface GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesGetOrderPlanningRequest {
    readonly orderId?: number

    readonly cargoItemId?: number
}

/**
 * Request parameters for generalCargoStockOccupanciesGetOrderPlanningByOrderIds operation in GeneralCargoStockOccupanciesApi.
 */
export interface GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesGetOrderPlanningByOrderIdsRequest {
    readonly orderIds?: Array<number>
}

/**
 * Request parameters for generalCargoStockOccupanciesPlanOrder operation in GeneralCargoStockOccupanciesApi.
 */
export interface GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesPlanOrderRequest {
    readonly updateGeneralCargoOrderPlanningDto?: UpdateGeneralCargoOrderPlanningDto
}

/**
 * Request parameters for generalCargoStockOccupanciesPutToStock operation in GeneralCargoStockOccupanciesApi.
 */
export interface GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesPutToStockRequest {
    readonly updateGeneralCargoStockOccupancyDto?: UpdateGeneralCargoStockOccupancyDto
}

/**
 * Request parameters for generalCargoStockOccupanciesTakeFromStock operation in GeneralCargoStockOccupanciesApi.
 */
export interface GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesTakeFromStockRequest {
    readonly updateGeneralCargoStockOccupancyDto?: UpdateGeneralCargoStockOccupancyDto
}

/**
 * Request parameters for generalCargoStockOccupanciesUploadDamageFile operation in GeneralCargoStockOccupanciesApi.
 */
export interface GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesUploadDamageFileRequest {
    readonly file?: File
}

/**
 * GeneralCargoStockOccupanciesApi - object-oriented interface
 */
export class GeneralCargoStockOccupanciesApi extends BaseAPI {
    /**
     * 
     * @param {GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesGetDamageInfoByOrderIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalCargoStockOccupanciesGetDamageInfoByOrderId(requestParameters: GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesGetDamageInfoByOrderIdRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralCargoStockOccupanciesApiFp(this.configuration).generalCargoStockOccupanciesGetDamageInfoByOrderId(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesGetDamagesByOrderIdsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalCargoStockOccupanciesGetDamagesByOrderIds(requestParameters: GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesGetDamagesByOrderIdsRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralCargoStockOccupanciesApiFp(this.configuration).generalCargoStockOccupanciesGetDamagesByOrderIds(requestParameters.orderIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesGetOrderPlanningRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalCargoStockOccupanciesGetOrderPlanning(requestParameters: GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesGetOrderPlanningRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralCargoStockOccupanciesApiFp(this.configuration).generalCargoStockOccupanciesGetOrderPlanning(requestParameters.orderId, requestParameters.cargoItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesGetOrderPlanningByOrderIdsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalCargoStockOccupanciesGetOrderPlanningByOrderIds(requestParameters: GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesGetOrderPlanningByOrderIdsRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralCargoStockOccupanciesApiFp(this.configuration).generalCargoStockOccupanciesGetOrderPlanningByOrderIds(requestParameters.orderIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesPlanOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalCargoStockOccupanciesPlanOrder(requestParameters: GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesPlanOrderRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralCargoStockOccupanciesApiFp(this.configuration).generalCargoStockOccupanciesPlanOrder(requestParameters.updateGeneralCargoOrderPlanningDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesPutToStockRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalCargoStockOccupanciesPutToStock(requestParameters: GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesPutToStockRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralCargoStockOccupanciesApiFp(this.configuration).generalCargoStockOccupanciesPutToStock(requestParameters.updateGeneralCargoStockOccupancyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesTakeFromStockRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalCargoStockOccupanciesTakeFromStock(requestParameters: GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesTakeFromStockRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralCargoStockOccupanciesApiFp(this.configuration).generalCargoStockOccupanciesTakeFromStock(requestParameters.updateGeneralCargoStockOccupancyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesUploadDamageFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalCargoStockOccupanciesUploadDamageFile(requestParameters: GeneralCargoStockOccupanciesApiGeneralCargoStockOccupanciesUploadDamageFileRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralCargoStockOccupanciesApiFp(this.configuration).generalCargoStockOccupanciesUploadDamageFile(requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
}

